export default __webpack_public_path__ + "static/media/1200px-Datadog_logo.svg.eccff8ab.png";